import React, { useState, useEffect, useMemo } from 'react';
import { useSelector,shallowEqual ,useDispatch}      from 'react-redux';
import { NavLink, useNavigate }          from 'react-router-dom';
import UserHelper from '../../common/utils/userHelper';
import axios from 'axios';
import { API_BASE_URL, API_GATEWAY_URL } from '../../config/constants';
import { getPartners, sentNewsletter } from '../../api/eventFooter';
import { getImage } from '../../utils/helper.ts';
import { IMAGES_BASE_PATH } from '../../config/constants';
import { size } from 'lodash';


interface FooterProps {
    isSocialFooter?: boolean;
    socialData:any
    show_partners_footer?:boolean;
    show_newsletter_footer?:boolean;
    data:any
  }
const Footer: React.FC<FooterProps> = ({isSocialFooter,socialData,show_partners_footer,show_newsletter_footer,data}) => {
    const eventData                         = useSelector((state: any) => state.eventData); 
   
  const event_id=UserHelper.getEventId();
  const [email, setEmail] = useState('');
  const [partners,setPartners]=useState<any>()

  const handleSubmit=(e:React.FormEvent)=>{
    e.preventDefault()
    const res=sentNewsletter(event_id,email);
  }

useEffect(() => {
  const fetchPartners = async () => {
    try {
      const response = await getPartners(event_id);
      console.log('Partners response:', response.data[0].logo);
      setPartners(response.data)
      // optionally: setState(response.data) if needed
    } catch (error) {
      console.error('Error fetching partners:', error);
    }
  };

  if (event_id) {
    fetchPartners();
  }
}, [event_id]);

  return (
    
  //  <!--Footer section-->
<footer className="footer-area">
    <div className="container-fluid pl-100 pr-100">
 {show_newsletter_footer  &&(
        <div className="row">
            <div className="col-md-6 col-lg-6 col-sm-12">

            </div>
        
                <div className="col-md-6 col-lg-6 col-sm-12">
                <div className="subscribe-form-area">

                  
                   <svg
  className="curve-left"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 104.833 76"
  width="104.833"
  height="76">
  <path
    fill='#000'
    d="M0.593,0C1.167-0.265,12.78,1.364,13.858,1.581
       c21.474,4.28,31.562,17.4,39.457,36.798
       c8.955,21.995,25.877,37.553,50.673,37.553
       c-0.006,0-103.371,0.002-103.371,0.002
       S0.53,0.029,0.593,0z"
  />
</svg>

                   

                    <form action="#" method="post" onSubmit={handleSubmit} className='newsletterbtn'>
                        <input type="email" name="email" value={email} placeholder='Your email address' onChange={(e)=>setEmail(e.target.value)} required/>
                        <button className='btn' type="submit" style={{color: eventData?.primary_text_color, backgroundColor: eventData.register_button_color}}>notify</button>
                    </form>
                      
                
                    <svg  className="curve-right" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="104.833px" height="76px" viewBox="0 0 104.833 76" enable-background="new 0 0 104.833 76">
                        <path fill='#000' d="M104.965,0C104.392-0.265,92.778,1.364,91.7,1.581c-21.475,4.28-31.562,17.4-39.457,36.798  C43.289,60.373,26.366,75.932,1.57,75.932c0.006,0,103.371,0.002,103.371,0.002S105.028,0.029,104.965,0z"/>
                   </svg>
                    </div>
                </div>
          
            
        </div>
        )}

        <div className="row pt-5">
            <div className="pl-100 col-lg-4 col-md-6 col-sm-12 text-sm-left text-center text-md-left footer-contact">
            {eventData?.website_logo?.key && (
                            <NavLink onClick={() => window.location.reload()} to='/' className="">
                                <img
                                src={IMAGES_BASE_PATH + eventData.website_logo.key}
                                alt="logo"
                                />
                            </NavLink>
                        )}
                <br/><br/>


                
                <p className="description"  dangerouslySetInnerHTML={{
                __html: data?.footer_text?.substring(0, 500),
              }}/>

<br/><br/>
               {isSocialFooter && (
               <h3>Follow Us</h3>
               )}

                    {isSocialFooter && (
                        <ul className="footer-social">
                            {socialData &&
                            socialData
                                .filter((item: any) => item.status)
                                .map((item: any) => {
                                const iconMap: { [key: string]: string } = {
                                    facebook: "icon-facebook",
                                    twitter: "icon-twitter",
                                    linkedin: "icon-linkedin-1",
                                    instagram: "icon-instagram",
                                    youtube: "icon-youtube-play",
                                    insta: "icon-instagram",
                                    tiktok: "icon-tiktok",
                                    pinterest: "icon-pinterest-circled",
                                    whatsapp: "icon-whatsapp",
                                    snapchat: "icon-snapchat-ghost",
                                    reddit: "icon-reddit",
                                    github: "icon-github",
                                    dribbble: "icon-dribbble",
                                    behance: "icon-behance",
                                    medium: "icon-medium",
                                    telegram: "icon-telegram",
                                    discord: "icon-discord",
                                };

                                const iconClass = iconMap[item.title.toLowerCase()] || "icon-link";

                                return (
                                    <li key={item._id}>
                                    <a
                                        href={
                                        item.url.startsWith("http") ? item.url : `https://${item.url}`
                                        }
                                        target={item.is_open_new_window ? "_blank" : "_self"}
                                        rel="noopener noreferrer"
                                        title={item.title}
                                    >
                                        <i className={iconClass}></i>
                                    </a>
                                    </li>
                                );
                                })}
                        </ul>
                        )}
   
                
            </div>


              <div className="pl-100 col-lg-4 col-md-6 col-sm-12 text-sm-left text-center text-md-left footer-contact">
                <h3>Event Info</h3>

              
                <ul>
                    <li><a href="#agenda" >Agenda</a></li>
                   <li><a href="#speakers" >Speakers</a></li>
                   <li><a href="#exhbitors" >Exhibitors</a></li>
                   <li><a href="#register" >Join the Event</a></li>
                </ul>



{show_partners_footer && partners&&
 <div className="instagram">
               <ul>
                {partners?.map((partner: any, index: number) => (
                    <li key={index}>
                        <a href="#_"><img src={getImage(partner.logo)} alt={`Partner ${index + 1}`} /></a>
                    </li>
                ))}
                </ul>
            </div>}





            </div>


            

            <div className="col-lg-4 col-md-6 col-sm-12 text-sm-left text-center text-md-left footer-contact">
                <h3>Get In Touch</h3>

                <p>{eventData.address}</p>
                <ul>
                    <li>
                        <a href={`mailto:${eventData.email}`} target="_blank" rel="noopener noreferrer">
                            <span className="icon-email"></span>
                            {eventData.email}
                        </a>
                    </li>
                    <li><a href="#" target="_blank"> <span className="icon-call"></span>{eventData.Phone} </a></li>
                    <li><a href="#" target="_blank"> <span className="icon-location-2"></span> {eventData.city}, {eventData.country} </a></li>
                </ul>

<br></br>



{eventData.support_email &&
              <div className='footer-contact'>
              <h3>Technical Support</h3>
              <ul>
                <li><span className="icon-email"></span> {eventData.support_email}</li>
                 <li><span className="icon-call"></span> {eventData.support_phone}</li>
              </ul>
            
              </div>
}



            </div>






        </div>


        <div className="copyright">
            <div className="row">
                <div className="col-md-6">
                    <ul>
                        <li><a href="https://www.avianet.aero/privacy/" target='new'>Privacy Policy</a></li>
                    </ul>
                </div>
                <div className="col-md-6">
                <p>Copyright 2026 all rights reserved. Powered by <a href="https://www.avianet.aero" target="_blank" rel="noopener noreferrer" style={{
    '--active-bg': eventData.primary_color 
  }}>AVIANET</a></p>
         
                </div>
            </div>
        </div>

    </div>

</footer>

  );
};

export default Footer;